<template>
  <a-menu-item key="moveToProject" @click="showMoveToProjectModal">
    <UserSwitchOutlined />&nbsp;移動至其他專案&nbsp;
  </a-menu-item>
  <a-modal v-model:open="isOpen" width="75%" title="移動人員與問卷" :maskClosable="isMaskClosable" 
        :cancelButtonProps="cancelButtonProps" :okButtonProps="okButtonProps" :confirm-loading="isMovingUser" 
        okText="移動" cancelText="關閉" @cancel="cancelMoveToProject" @ok="moveUserQuests">
      <a-divider />
      <a-space direction="vertical">
        <a-space>
          所屬專案資訊：
          <a-tag :bordered="false" color="volcano">專案編號</a-tag>{{ props.project.projectNo }}
          <a-divider type="vertical"/>
          <a-tag :bordered="false" color="volcano">專案名稱</a-tag>{{ props.project.projectName }}
          <a-divider type="vertical"/>
          <a-tag :bordered="false" color="volcano">客戶名稱</a-tag>{{ props.project.companyName }}
        </a-space>
        <a-space>
          選取人員資訊：
          <a-tag :bordered="false" color="processing">證件編號</a-tag>{{ props.userRecord.personalNo }}
          <template v-if="props.userRecord.name != null">
            <a-divider type="vertical"/>
            <a-tag :bordered="false" color="processing">人員姓名</a-tag>{{ props.userRecord.name }}
            <a-divider type="vertical"/>
            <a-tag :bordered="false" color="processing">工/學號</a-tag>{{ props.userRecord.jobNo }}
          </template>
        </a-space>
      </a-space>
      <a-table style="width: 100%" 
        :loading="isLoading"
        :columns="projectColumns" 
        :data-source="formState.projectData" 
        :row-selection="{ selectedRowKeys: formState.selectedProjects, type: 'radio', onChange: onProjectSelectChange}"
        :pagination="pagination" @change="tablePageChange">
        <template #title>
            <a-input-search v-model:value="formState.searchText" @change="onSearchChange" 
              placeholder="輸入搜尋文字" style="width: 240px; float: right; padding-bottom: 12px" @search="reloadProjectList"/>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'projectNo'">
              <div class="hyperlink" @click="onProjectSelect(record.key)">
                {{ record.projectNo }}
              </div>
            </template>
          <template v-if="column.key === 'projectStatus'">
            <span>
              <a-tag :color="ProjectStatusColors.get(record.projectStatus)">
                <template #icon v-if="record.projectStatus === 'COMPLETED'">
                  <CheckCircleOutlined />
                </template>
                <template #icon v-else-if="record.projectStatus === 'PROCESSING'">
                  <SyncOutlined />
                </template>
                <template #icon v-else-if="record.projectStatus === 'WAIT_PROCESS'">
                  <ClockCircleOutlined />
                </template>
                <template #icon v-else-if="record.projectStatus === 'VOID'">
                  <MinusCircleOutlined />
                </template>
                {{ ProjectStatusNames.get(record.projectStatus) }}
              </a-tag>
              </span>
          </template>
        </template>
      </a-table>
  </a-modal>
</template>
<script setup>
import { UserSwitchOutlined, CheckCircleOutlined, SyncOutlined, ClockCircleOutlined, MinusCircleOutlined } from '@ant-design/icons-vue';
import { ref, reactive, defineProps, defineEmits } from 'vue';
import { message } from 'ant-design-vue';
import { ProjectStatusNames, ProjectStatusColors } from "@/common";
import common from "@/common";
import config from "@/config";

const props = defineProps(['project', 'userRecord']);

const emit = defineEmits(['cancel', 'submit-success']);

const moveToProjectForm = ref();
const isOpen = ref(false);
const formState = reactive({});
const isMaskClosable = ref(false);
const isMovingUser = ref(false);
const isProjectUnSelected = ref(true);
const cancelButtonProps = ref({
  disabled: isMovingUser
});
const okButtonProps = ref({
  disabled: isProjectUnSelected
});

const isLoading = ref(false);
const projectColumns = ref([
  {
    title: "專案編號",
    dataIndex: "projectNo",
    key: "projectNo",
    align: "left",
    width: "100px",
  },
  {
    title: "專案狀態",
    dataIndex: "projectStatus",
    key: "projectStatus",
    align: "center",
    width: "140px"
  },
  {
    title: "專案名稱",
    dataIndex: "projectName",
    key: "projectName",
    align: "left",
  },
  {
    title: "客戶名稱",
    dataIndex: "companyName",
    key: "companyName",
    align: "left",
  }
]);

const pagination = ref({
  current: 1,
  pageSize: 5
});

const tablePageChange = (page) => {
  pagination.value.current = page.current;
  pagination.value.pageSize = page.pageSize;
}

const reloadProjectList = () => {
  isLoading.value = true;
  common.postRequest(config.mgmtProjectQuestGetMovingProjects, {
    searchText: formState.searchText,
    projectUrl: props.project.url
  }, (response) => {
    isLoading.value = false;
    formState.projectData = response.data;
    formState.selectedProjects = [];
    isProjectUnSelected.value = true;
    pagination.value.current = 1;
  }, () => {
    isLoading.value = false;
  });
}

const showMoveToProjectModal = () => {
  if (moveToProjectForm.value != null) {
    moveToProjectForm.value.resetFields();
  }
  formState.projectUrl = props.project.url;
  formState.personalNo = props.userRecord.personalNo;
  formState.searchText = "";
  pagination.value.current = 1;
  pagination.value.pageSize = 5;
  reloadProjectList();
  isOpen.value = true;
}

const onSearchChange = () => {
  if (common.isNotEmpty(formState.searchText)) {
    return ;
  }
  reloadProjectList();
}

const onProjectSelect = (rowKey) => {
  formState.selectedProjects = [];
  formState.selectedProjects.push(rowKey);
  isProjectUnSelected.value = formState.selectedProjects.length == 0;
}

const onProjectSelectChange = (selectedRowKeys) => {
  formState.selectedProjects = selectedRowKeys;
  isProjectUnSelected.value = formState.selectedProjects.length == 0;
}

const cancelMoveToProject = () => {
  isOpen.value = false;
  emit('cancel');
}

const moveUserQuests = () => {
  let selectedProject = null;
  for (let i = 0 ; i < formState.projectData.length; i++) {
    if (formState.projectData[i].key === formState.selectedProjects[0]) {
      selectedProject = formState.projectData[i];
      break;
    }
  }
  if (selectedProject == null) {
    common.openErrorModal(500, '移動失敗', "請確認是否已選擇欲移動之目標專案！");
    return ;
  }
  common.openConfirmModal(500, '移動確認', "是否確認移動人員「" + props.userRecord.personalNo + "」至以下專案：\n" + 
    "專案編號「" + selectedProject.projectNo + "」\n" + 
    "專案名稱「" + selectedProject.projectName + "」\n" +
    "客戶名稱「" + selectedProject.companyName + "」\n" + 
    "註：若該專案已存在該使用者所填寫之問卷，便會移動失敗。", () => {
      return new Promise(function(resolve, reject) {
        isMovingUser.value = true;
        common.postRequest(config.mgmtProjectQuestMoveUserQuestToProject, {
          originProjectUrl: props.project.url,
          targetProjectUrl: selectedProject.key,
          personalNo: props.userRecord.personalNo
        }, (response) => {
          console.log(response);
          isMovingUser.value = false;
          resolve();
          if (common.isEmpty(response.data)) {
            message.success("人員「" + props.userRecord.personalNo + "」成功移動至專案「" + selectedProject.projectNo + "」");
            isOpen.value = false;
            emit('submit-success');
          } else {
            common.openErrorModal(600, "移動失敗", response.data);
            reject();
          }
        }, () => {
          isMovingUser.value = false;
          reject();
        });
      });
  });
}

</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
.hyperlink {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
</style>